<template>
  <el-form
      ref="form"
      :model="form">
    <el-row
        type="flex"
        class="gj-picker">
      <div class="gj-picker__editor">
        <el-form-item
            label="类型选择"
            prop="matchType"
            :rules="[
              { required: true, message: '请选择匹配类型', trigger: ['change'] }
            ]"
            style="margin-bottom: 6px;margin-top: 6px;">
          <el-radio v-model="form.matchType" :label="0">否定精准</el-radio>
          <el-radio v-model="form.matchType" :label="1">否定词组</el-radio>
        </el-form-item>
        <div style="margin-bottom: 10px;">
          <gj-textarea
              v-model="keyword"
              :styles="{ height: '295px', 'border-color': this.errorKeyword ? '#F56C6C' : '' }"
              placeholder="请输入否定关键词，一行一个，回车换行">
          </gj-textarea>
        </div>
        <el-row
            type="flex"
            align="middle"
            justify="space-between"
            class="gj-picker__editor--footer">
          <span :class="{red: errorKeyword}">关键词不得包含特殊字符，如@、#、*和$等</span>
          <gj-button
              type="primary"
              @click="addKeyword"
              :disabled="!isMeaningful(keyword)"
          >添加</gj-button>
        </el-row>
      </div>
      <div class="gj-picker__table">
        <div class="gj-picker__table--title">
          已添加 {{form.items.length}} 个{{title}}<span class="gj-picker__table--tip">（最多可添加1000个，会过滤重复的{{title}}）</span>
        </div>
        <gj-table
            ref="gjTable"
            name="adAddKeyword"
            :index="false"
            :show-pagination="false"
            :adapt-height="false"
            :height="358"
            :data="form.items"
            :columns="columns">
          <template v-slot:header:op>
            <gj-button
                type="text"
                @click="deleteAllItem()"
            >全部移除</gj-button>
          </template>
          <template v-slot:op="{ index, row }">
            <gj-button
                type="text"
                @click="deleteItem(index, row)"
            >移除</gj-button>
          </template>
        </gj-table>
      </div>
    </el-row>
    <div class="gj-picker-solid"></div>
  </el-form>
</template>

<script>
  import {formMixin, isMeaningfulMixin} from "@/minxins";
  import {isMeaningful, unique} from "@/utils/common";

  export default {
    name: "app-neg-keyword-picker",
    mixins: [isMeaningfulMixin, formMixin],
    props: {
      title: {
        required: true,
      },
    },
    created() {
      this.columns[0].header = this.title;
    },
    data() {
      return {
        keyword: null,
        keywordNum: 0,
        columns: [
          {id: 'keyword', header: '否定关键词', field: 'keyword', minWidth: '200px'},
          {id: 'matchType', header: '匹配类型',field: 'matchTypeText', width: '180px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '80'},
        ],
        errorKeyword: false,
        matchTypeOption: [
          {id: 0, text: '否定精准'},
          {id: 1, text: '否定词组'}
        ],
        keywordStyle: {height: '292px'}
      }
    },
    watch: {
      keyword(val) {
        this.errorKeyword = !/^[^!#%<>@*$]*$/.test(val);
        // if (title === '否定关键词'
        //   && isMeaningful(val) && val.split(' ')) {
        //
        // }
      }
    },
    methods: {
      addKeyword() {
        const keywords = [];
        this.keyword.split('\n')
          .map(item => item.replace(/^(\s|\n)+|(\s|\n)+?$/, ''))
          .filter(item => isMeaningful(item) && !/\n+/.test(item))
          .forEach(item => {
            keywords.push({
              keyword: item,
              matchTypeText: this.matchTypeOption.find(e => e.id === this.form.matchType).text,
              matchType: this.form.matchType
            });
          });
        this.form.items = unique(this.form.items.concat(keywords), ['keyword', 'matchType']);
        this.keyword = null;
      },
      deleteAllItem() {
        this.form.items = [];
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
      },
      formValidate() {
        const valid = this.form.items.length > 0;
        if (!valid) {
          this.$gjMessage.error('请添加否定关键词');
        }
        return valid;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "picker";
  .gj-picker__editor {
    width: 49%;
    padding: 0 10px;
    &::before {
      content: "否定关键词";
      left: -73px;
    }
  }
  .gj-picker__editor{
    height: 398px;
  }
  /deep/ .gj-picker__table{
    .vxe-table--border-line{
      border: none !important;
    }
  }
</style>
